<template>
  <SbLink
    :class="['base-back-link', className]"
    as="router-link"
    :to="routeTo"
    :label="label"
    :disabled="isDisabled"
    :icon="icon"
    subtle
    @click="$emit('click')"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import { SbLink } from '@storyblok/design-system'
import type { IconColor, IconName } from '@storyblok/design-system'

const props = withDefaults(
  defineProps<{
    label?: string
    routeTo?: RouteLocationRaw
    icon?: IconName
    iconColor?: IconColor
    isDisabled?: boolean
    class?: string
  }>(),
  {
    label: '',
    routeTo: () => ({
      path: '/',
    }),
    icon: 'arrow-left',
    iconColor: 'primary',
    class: undefined,
  },
)

const className = computed(() => props.class)

defineEmits<{
  (e: 'click'): void
}>()
</script>
